import API from "../axios/API";
import * as types from "../../reduxStore/types/subscription";

export const submitSubscription = (restaurantId, data) => {
  console.log(`adfafasdfasdfadfafasddata ==>`, data);
  return async (dispatch, getState) => {
    let outletResponse;

    try {
      outletResponse = await API.post(
        `restaurants/${restaurantId}/subscription-configurations`,
        data,
      );
    } catch (error) {
      outletResponse = error;
    }

    return outletResponse;
  };
};
